(() => {
  const CART_EVENT = 'shopify:cart:lines-update';

  const setCartCount = (count) => {
    const qty = Math.max(0, Number.parseInt(count, 10) || 0);

    document.querySelectorAll('[data-vigo-cart-count]').forEach((node) => {
      node.textContent = String(qty);
      node.hidden = qty < 1;
    });

    document.querySelectorAll('[data-vigo-cart-foot-count]').forEach((node) => {
      node.textContent = `(${qty})`;
      node.hidden = qty < 1;
    });
  };

  const fetchCartCount = async () => {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const cart = await response.json();
      setCartCount(cart?.item_count ?? cart?.total_quantity ?? 0);
    } catch (_) {
      /* The standard Shopify cart event remains the primary sync path. */
    }
  };

  const initOne = root => {
    if (!root || root.dataset.vigoInit === '1') return;
    root.dataset.vigoInit = '1';
    const header = root.querySelector('[data-vigo-header]');
    const menu = root.querySelector('[data-vigo-mobile-menu]');
    const toggle = root.querySelector('[data-vigo-menu-toggle]');
    const close = root.querySelector('[data-vigo-menu-close]');
    if (!header) return;
    let ticking = false, lastFocus = null;
    const update = () => { header.classList.toggle('is-compact', window.scrollY > 22); ticking = false; };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, {passive:true});
    update();
    const shut = () => { if(!menu||!toggle)return; menu.classList.remove('is-open'); menu.setAttribute('aria-hidden','true'); toggle.setAttribute('aria-expanded','false'); document.body.classList.remove('vigo-menu-open'); lastFocus?.focus?.(); };
    const open = () => { if(!menu||!toggle)return; lastFocus=document.activeElement; menu.classList.add('is-open'); menu.setAttribute('aria-hidden','false'); toggle.setAttribute('aria-expanded','true'); document.body.classList.add('vigo-menu-open'); requestAnimationFrame(()=>close?.focus()); };
    toggle?.addEventListener('click', () => menu?.classList.contains('is-open') ? shut() : open());
    close?.addEventListener('click', shut);
    menu?.querySelectorAll('a,[data-vigo-menu-action]').forEach(el=>el.addEventListener('click',shut));
    document.addEventListener('keydown', e => { if(e.key==='Escape' && menu?.classList.contains('is-open')) shut(); });
    window.addEventListener('resize', () => { if(innerWidth>900 && menu?.classList.contains('is-open')) shut(); }, {passive:true});
  };

  const init = (ctx=document) => ctx.querySelectorAll?.('[data-vigo-header-section]').forEach(initOne);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init()); else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));

  /*
   * Horizon emits this standard event for product adds AND cart-drawer
   * quantity changes.  Updating our custom Vigo header here means the badge
   * is already correct the moment the drawer closes, without a page refresh.
   */
  document.addEventListener(CART_EVENT, (event) => {
    const promise = event?.promise;
    if (promise && typeof promise.then === 'function') {
      promise
        .then((result) => {
          const cart = result?.cart;
          const count = cart?.totalQuantity ?? cart?.item_count ?? cart?.total_quantity;
          if (count !== undefined) setCartCount(count);
          else fetchCartCount();
        })
        .catch(() => fetchCartCount());
    } else {
      fetchCartCount();
    }
  });

  /* Covers bfcache / restored tabs and any third-party cart mutations. */
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) fetchCartCount();
  });
})();
